// EducaMaker por planes — P1 (popup de upsell para free/standard).
// Plan maestro: docs/architecture/EDUCAMAKER_ACCESO_PLAN_MAESTRO.md 4.1.
//
// Es una PUERTA, no un anuncio: se muestra cada vez que un usuario sin
// EducaMaker en su plan intenta entrar. AntD Modal aporta overlay, cierre
// con ESC/click fuera, focus-trap y role="dialog" de serie.

import React, { useCallback } from "react";
import { Button, Modal } from "antd";
import { CheckCircleFilled } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

import { BrandThemeProvider } from "../../../../ui";
import {
  UPSELL_PRIMARY_URL,
  UPSELL_SECONDARY_URL,
  trackEducamakerUpsell,
} from "../../../../Utils/educamakerAccess";
import styles from "./EducamakerUpsellModal.module.scss";

export function EducamakerUpsellModal({ open, onClose, planKey }) {
  const { t } = useTranslation("scenes");

  const handleCta = useCallback(
    (content, url) => {
      trackEducamakerUpsell("educamaker_upsell_cta", { planKey, content });
      window.open(url, "_blank", "noopener,noreferrer");
      onClose();
    },
    [planKey, onClose],
  );

  return (
    <BrandThemeProvider>
      <Modal
        open={open}
        onCancel={onClose}
        footer={null}
        width={480}
        centered
        destroyOnHidden
        // El title da nombre accesible al dialogo (AntD lo referencia via
        // aria-labelledby e ignora props aria-* sueltos). Visualmente se
        // oculta (sr-only en el scss): el titulo visible es el h3 del cuerpo.
        title={t("upsell.title")}
        className={styles.modal}
      >
        <div className={styles.body}>
          <div className={styles.illustration} aria-hidden>
            🏗️
          </div>

          <h3 className={styles.title}>{t("upsell.title")}</h3>

          <p className={styles.text}>{t("upsell.body")}</p>

          <ul className={styles.bullets}>
            {["bullet1", "bullet2", "bullet3"].map((key) => (
              <li key={key} className={styles.bullet}>
                <CheckCircleFilled className={styles.check} aria-hidden />
                <span>{t(`upsell.${key}`)}</span>
              </li>
            ))}
          </ul>

          <Button
            type="primary"
            size="large"
            block
            onClick={() => handleCta("primary", UPSELL_PRIMARY_URL)}
          >
            {t("upsell.ctaPrimary")} →
          </Button>

          <button
            type="button"
            className={styles.secondary}
            onClick={() => handleCta("secondary", UPSELL_SECONDARY_URL)}
          >
            {t("upsell.ctaSecondary")}
          </button>

          <button type="button" className={styles.dismiss} onClick={onClose}>
            {t("upsell.dismiss")}
          </button>
        </div>
      </Modal>
    </BrandThemeProvider>
  );
}
